import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZonaRoutingModule } from './zona.routing';
import { ZonaComponent } from './zona.component';
import { ZonaListComponent } from './list/zona-list.component';
import { ZonaSaveComponent } from './save/zona-save.component';
import { ZonaViewComponent } from './view/zona-view.component';
import { MatTableModule, MatButtonModule, MatInputModule, MatSlideToggleModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FabButtonGroupModule } from 'src/app/shared/fabbuttongroup/fabbuttongroup.module';
import { SectionBarModule } from 'src/app/shared/sectionbar/sectionbar.module';
import { GridEmptyModule } from 'src/app/shared/gridempty/gridempty.module';
import { TitlebarModule } from 'src/app/shared/titlebar/titlebar.module';
import { HeaderModule } from 'src/app/shared/header/header.module';
import { LoaderModule } from 'src/app/shared/loader/loader.module';
import { SnackbarModule } from 'src/app/shared/snackbar/snackbar.module';
import { ZonaRegionListComponent } from './listZonaRegion/zona-region-list.component';

@NgModule({
  imports: [
    CommonModule,
    ZonaRoutingModule,
    MatTableModule,
    MatButtonModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    FabButtonGroupModule,
    SectionBarModule,
    GridEmptyModule,
    TitlebarModule,
    HeaderModule,
    LoaderModule,
    SnackbarModule,
    MatSlideToggleModule
  ],
  declarations: [
    ZonaComponent,
    ZonaListComponent,
    ZonaSaveComponent,
    ZonaViewComponent,
    ZonaRegionListComponent,
  ]
})
export class ZonaModule { }
